import { getPressureBaseZIndex } from './getPressureBaseZIndex'
import type { TPressureReading } from './getPressureReading'

export const sortSelectedEmittersAndBestReadingsFirst = <
  T extends { emitterType: string; isRunning: boolean; reading: TPressureReading },
>(
  rows: T[],
  selectedEmitters: string[],
): T[] => {
  const rank = ({ isRunning, reading }: T) => getPressureBaseZIndex({ isRunning, state: reading.state })

  return [...rows].sort(
    (a, b) =>
      Number(selectedEmitters.includes(b.emitterType)) - Number(selectedEmitters.includes(a.emitterType)) ||
      rank(b) - rank(a) ||
      (b.reading.psi ?? 0) - (a.reading.psi ?? 0),
  )
}
